/**
 * Parâmetros de `billing.business_properties` (AF-4126): leitura e alteração pela tela
 * "Parâmetros Settlement/Billing". Só ADMIN; o billing devolve 403 para os demais.
 *
 * O `value` viaja sempre como texto: os parâmetros JSON vão serializados, e o billing os valida
 * contra o schema de cada um antes de gravar.
 */
import { Auth } from 'aws-amplify';
import appConfig from '../../../../config/app-config';

const { address: API_URL, key: API_KEY } = appConfig.apis.billing;

export interface BusinessProperty {
    name: string;
    description: string | null;
    value: string | null;
    updatedBy: string | null;
    updatedAt: string | null;
}

const getHeaders = async () => {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    return {
        'x-api-key': API_KEY,
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
    };
};

const parseOrThrow = async (res: Response) => {
    const body = await res.json().catch(() => null);
    if (!res.ok) {
        throw new Error(body?.message || `Erro HTTP ${res.status}`);
    }
    return body;
};

export const listBusinessProperties = async (): Promise<BusinessProperty[]> => {
    const headers = await getHeaders();
    const res = await fetch(`${API_URL}/business-properties`, { headers });
    const body = await parseOrThrow(res);
    return body?.data || [];
};

export const updateBusinessProperty = async (name: string, value: string): Promise<BusinessProperty> => {
    const headers = await getHeaders();
    const res = await fetch(`${API_URL}/business-properties/${encodeURIComponent(name)}`, {
        method: 'PUT', headers, body: JSON.stringify({ value }),
    });
    const body = await parseOrThrow(res);
    return body.data;
};
